import * as React from "react";

import { useSelector } from "react-redux";
import styled from "styled-components";

import { selectCheckStateFromMainState } from "../../Store/AdviceState";
import { selectTextLength } from "../../Store/PadState";
import {Fonts} from "../../Styles";
import { AcceptIcon } from "../Icons";

const StyledNoAdvice = styled.div`
    text-align: center;

    span {
        display: inline-block;
        border: 1px solid currentColor;
        border-radius: 50%;
    }

    svg {
        display: block;
        margin: 0 auto;
    }

    p {
        font-family: ${Fonts.theinhardt};
        font-size: 26px;
        line-height: 31px;
        margin-top: 20px;
        padding: 0 20px;
    }
`;

export const NoAdvice = () => {
    const {spellAdvices, styleAdvices} = useSelector(selectCheckStateFromMainState);
    const textLength = useSelector(selectTextLength);

    if (textLength > 0 && spellAdvices.length === 0 && styleAdvices.length === 0) {
        return (
            <StyledNoAdvice>
                <span><AcceptIcon height={42} width={42} /></span>
                <p>Es wurden keine Fehler gefunden.</p>
            </StyledNoAdvice>
        )
    }

    return null;
}
